import { useEffect } from 'react';
import { drawImageCover, drawImageContainScaled } from '../lib/imageUtils';
import { drawStaticDiscFace, drawStaticSheen } from '../lib/drawFrame';

function sizeCanvas(canvas, w, h) {
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  canvas.width = w * dpr; canvas.height = h * dpr;
  canvas.style.width = w + 'px'; canvas.style.height = h + 'px';
  const ctx = canvas.getContext('2d');
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  return ctx;
}

// Background layer -- redraws only on background/frame-size change.
export function useBackgroundLayer(canvasRef, background, cssW, cssH) {
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || cssW <= 0 || cssH <= 0) return;
    const ctx = sizeCanvas(canvas, cssW, cssH);
    ctx.clearRect(0, 0, cssW, cssH);
    if (background.type === 'image' && background.imageEl) {
      drawImageCover(ctx, background.imageEl, 0, 0, cssW, cssH);
    } else {
      ctx.fillStyle = background.color || '#0f0f10';
      ctx.fillRect(0, 0, cssW, cssH);
    }
  }, [background, cssW, cssH]);
}

// Disc-face layer (unrotated appearance) -- redraws only when the disc's
// LOOK changes, deliberately excluding disc.rpm (rotation is a pure CSS
// transform applied elsewhere, never a texture redraw).
export function useDiscFaceLayer(discCanvasRef, sheenCanvasRef, disc, discOutputPx) {
  useEffect(() => {
    const canvas = discCanvasRef.current;
    if (!canvas || discOutputPx <= 0) return;
    const ctx = sizeCanvas(canvas, discOutputPx, discOutputPx);
    drawStaticDiscFace(ctx, disc, discOutputPx);

    if (disc.designMode === 'vinyl') {
      const sheenCanvas = sheenCanvasRef.current;
      if (sheenCanvas) {
        const sctx = sizeCanvas(sheenCanvas, discOutputPx, discOutputPx);
        drawStaticSheen(sctx, discOutputPx);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disc.imageEl, disc.designMode, disc.shape, disc.vinyl, disc.spindleVisible, disc.centerHole, discOutputPx]);
}

// Foreground overlay -- redraws only on foreground/frame-size change.
export function useForegroundLayer(canvasRef, foreground, cssW, cssH) {
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || cssW <= 0 || cssH <= 0) return;
    const ctx = sizeCanvas(canvas, cssW, cssH);
    ctx.clearRect(0, 0, cssW, cssH);
    if (foreground && foreground.imageEl) {
      drawImageContainScaled(ctx, foreground.imageEl, 0, 0, cssW, cssH, foreground.scale);
    }
  }, [foreground, cssW, cssH]);
}
